import create from "zustand";

interface StoreState {
  motivo: number | undefined;
  observacao: string | undefined;
  reagendamentoQuantidadeDias: number | undefined;
  planoOperacionalOperacaoTalhaoIds: string[];

  setMotivo: (motivo: number | undefined) => void;
  setObservacao: (observacao: string | undefined) => void;
  setReagendamentoQuantidadeDias: (reagendamentoQuantidadeDias: number | undefined) => void;
  setPlanoOperacionalOperacaoTalhaoIds: (planoOperacionalOperacaoTalhaoIds: string | string[]) => void;
  reset: () => void;
}

const useStore = create<StoreState>((set) => ({
  tipoAlteracao: undefined,
  motivo: undefined,
  observacao: undefined,
  reagendamentoQuantidadeDias: undefined,
  planoOperacionalOperacaoTalhaoIds: [],

  setMotivo: (motivo) => {
    set(state => ({ motivo }));
  },
  setObservacao: (observacao) => {
    set(state => ({ observacao }));
  },
  setReagendamentoQuantidadeDias: (reagendamentoQuantidadeDias) => {
    set(state => ({ reagendamentoQuantidadeDias }));
  },
  setPlanoOperacionalOperacaoTalhaoIds: (value) =>
    set((state) => ({
      planoOperacionalOperacaoTalhaoIds: Array.isArray(value)
        ? value
        : [...state.planoOperacionalOperacaoTalhaoIds, value],
    })),
  reset: () =>
    set((state) => ({
      motivo: undefined,
      observacao: undefined,
      reagendamentoQuantidadeDias: undefined,
      planoOperacionalOperacaoTalhaoIds: [],
    })),
}));

export default useStore;
